import Markdown from "react-markdown";

import { ContainerStyled } from "./TechnologiesBrag.styled";

export interface TechnologiesBragContent {
  header: string;
  body: string;
}

interface TechnologiesBragProps extends TechnologiesBragContent {
  className?: string;
  backgroundGradient?: boolean;
}

export const TechnologiesBrag = ({
  header,
  body,
  className,
  backgroundGradient = true,
}: TechnologiesBragProps) => {
  return (
    <ContainerStyled
      className={className}
      backgroundGradient={backgroundGradient}
    >
      <p>{header}</p>
      <Markdown>{body}</Markdown>
    </ContainerStyled>
  );
};
